module.exports = __webpack_public_path__ + "img/inserma_susmagpro.a5f4f3c9.png";